<ng-container *ngIf="cs.vm$ | async as vm">
  <dgx-components-grid-section>
    <dgx-components-grid-container>
      <dgx-components-grid-row>
        <dgx-components-grid-column [md]="12" [xs]="12">
          <div *ngIf="vm.popularVideos.length">
            <dgx-components-grid-section>
              <dgx-components-grid-container>
                <dgx-components-grid-row>
                  <dgx-components-grid-column [md]="12" [xs]="12">
                    <dgx-components-video-list-block
                      [autoPlay]="false"
                      [body]="vm.popularVideosBody"
                      [hideControlPanel]="true"
                      [hideFullScreen]="true"
                      [title]="vm.popularVideosTitle"
                      [videos]="vm.popularVideos"
                      [navLink]="vm.viewAllVideosLink"
                    />
                  </dgx-components-grid-column>
                </dgx-components-grid-row>
              </dgx-components-grid-container>
            </dgx-components-grid-section>
          </div>
          <div class="mt-4" (click)="popularArticleClick($event)">
            <dgx-components-popular-link-list-block
              data-testid="popular-articles"
              *ngIf="vm.popularArticles.length"
              [navigationLinks]="vm.popularArticles"
              [title]="vm.popularArticlesTitle"
            />
          </div>

          <!-- remove it for now need to check again with product -->
          <!-- <dgx-components-multiple-button-content-card
            [body]="vm.repairRedirectBody"
            [border]="false"
            [dropshadow]="false"
            [icon]="vm.repairRedirectIconName"
            [primaryNavigationLink]="vm.repairRedirectPrimaryLink"
            [secondaryNavigationLink]="vm.repairRedirectSecondaryLink"
            [textAlign]="'left'"
            [theme]="'decoration-color-4'"
            [title]="vm.repairRedirectTitle"
          /> -->
        </dgx-components-grid-column>
      </dgx-components-grid-row>
    </dgx-components-grid-container>
  </dgx-components-grid-section>
</ng-container>
